import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8c6934b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "full-wrap my-auto mx-auto flex flex-row rounded-1xl" }
const _hoisted_2 = { class: "keyboard flex flex-col justify-center" }
const _hoisted_3 = { class: "keyboard-part2 flex flex-col justify-center" }
const _hoisted_4 = { class: "keyboard-num flex flex-col justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.keys, (line, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "flex flex-row keyboard-line my-1",
          key: idx
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(line, (kk) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["whitespace-pre-wrap flex place-content-center text-sm ml-2 box-border cursor-pointer border key", [
            {
              normal: !_ctx.keyState.has(kk.k),
              active: _ctx.keyState.has(kk.k),
              '-two-line': kk.v.indexOf('\n') >= 0,
              '-pressed': _ctx.pressed.has(kk.k),
            },
            'key-' + kk.k,
          ]]),
              key: kk.k
            }, _toDisplayString(kk.v), 3))
          }), 128))
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.part2Keys, (line, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "flex flex-row keyboard-line my-1",
          key: idx
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(line, (kk) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["whitespace-pre-wrap flex place-content-center text-sm ml-2 box-border cursor-pointer border key", [
            {
              normal: !_ctx.keyState.has(kk.k),
              active: _ctx.keyState.has(kk.k),
              '-two-line': kk.v.indexOf('\n') >= 0,
              '-pressed': _ctx.pressed.has(kk.k),
            },
            'key-' + kk.k,
          ]]),
              key: kk.k
            }, _toDisplayString(kk.v), 3))
          }), 128))
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numPadKey, (line, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "flex flex-row keyboard-line my-1",
          key: idx
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(line, (kk) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["whitespace-pre-wrap flex place-content-center text-sm ml-2 box-border cursor-pointer border key", [
            {
              normal: !_ctx.keyState.has(kk.k),
              active: _ctx.keyState.has(kk.k),
              '-two-line': kk.v.indexOf('\n') >= 0,
              '-pressed': _ctx.pressed.has(kk.k),
            },
            'key-' + kk.k,
          ]]),
              key: kk.k
            }, _toDisplayString(kk.v), 3))
          }), 128))
        ]))
      }), 128))
    ])
  ]))
}